/**
 * Códigos cortos (1–2 letras) para plantilla calendario de tareo simple.
 * También se aceptan los slugs completos (asistio, falta, …).
 */

export const TAREO_EVENTO_CODIGOS = [
  { codigo: 'X', tipo: 'asistio', nombre: 'Asistió' },
  { codigo: 'F', tipo: 'falta', nombre: 'Falta' },
  { codigo: 'FE', tipo: 'feriado', nombre: 'Feriado' },
  { codigo: 'FL', tipo: 'feriado_laborado', nombre: 'Feriado Laborado' },
  { codigo: 'D', tipo: 'descanso', nombre: 'Descanso' },
  { codigo: 'DL', tipo: 'descanso_laborado', nombre: 'Descanso Laborado' },
  { codigo: 'DM', tipo: 'descanso_medico', nombre: 'Descanso Médico' },
  { codigo: 'RM', tipo: 'reposo_medico', nombre: 'Reposo Médico' },
  { codigo: 'SE', tipo: 'subsidio_por_enfermedad', nombre: 'Subsidio por Enfermedad' },
  { codigo: 'P', tipo: 'permiso', nombre: 'Permiso' },
  { codigo: 'S', tipo: 'suspension', nombre: 'Suspensión' },
  { codigo: 'V', tipo: 'vacaciones', nombre: 'Vacaciones' },
];

/** Iniciales de día: Dom=0 … Sáb=6 (JS getDay). Miércoles = X para no chocar con Martes = M. */
export const DIA_SEMANA_LETRA = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];

export const MESES_TAREO = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const ALIAS_CODIGO = {
  A: 'asistio', // alias de X
  AS: 'asistio',
};

/**
 * Resuelve un valor de celda (código corto o slug) a tipo_evento canónico.
 * Vacío / "-" → null (sin registro ese día).
 */
export function resolverTipoEventoDesdeCodigo(valor) {
  const raw = String(valor ?? '').trim();
  if (!raw || raw === '-' || raw === '—' || raw === '.' || raw === '–') return null;

  const upper = raw.toUpperCase();
  if (ALIAS_CODIGO[upper]) return ALIAS_CODIGO[upper];

  const byCode = TAREO_EVENTO_CODIGOS.find((c) => c.codigo === upper);
  if (byCode) return byCode.tipo;

  const slug = raw.toLowerCase().replace(/\s+/g, '_');
  const byTipo = TAREO_EVENTO_CODIGOS.find((c) => c.tipo === slug);
  if (byTipo) return byTipo.tipo;

  return slug;
}

export function diasDelMes(year, monthIndex0) {
  return new Date(year, monthIndex0 + 1, 0).getDate();
}

export function letraDiaSemana(year, monthIndex0, day) {
  const dow = new Date(year, monthIndex0, day).getDay();
  return DIA_SEMANA_LETRA[dow];
}
